module.exports = __webpack_public_path__ + "78701cf16addfd67215b1244e1a655f4.svg";